
export const Theme = {
  input: [
    'w-4 h-4 text-primary-500 bg-gray-100 border-neutral-200 cursor-pointer self-center',
    'focus:ring-2 focus:ring-primary-500',
    'disabled:text-neutral-400 disabled:cursor-not-allowed',
    'dark:ring-offset-gray-800 dark:border-gray-600',
    'dark:focus:ring-primary-500'
  ],
  label: [
    'text-sm text-gray-900 ms-4 cursor-pointer',
    'dark:text-gray-300'
  ],
  labelDisabled: [
    'cursor-default',
    'dark:text-gray-500'
  ]
};
